module.exports = __webpack_public_path__ + "media/V22.e2430c96.mp4";